/* eslint-disable @typescript-eslint/no-explicit-any */
import { localStorageAvailable } from './storage_check';

export function localSet(key: string, value: string): boolean {
   if (localStorageAvailable()) {
      window.localStorage.setItem(key, value);
      return true;
   } else {
      return false;
   }
}

export function localGet(key: string): string | null {
   if (localStorageAvailable()) {
      return window.localStorage.getItem(key);
   } else {
      return null;
   }
}

export function localSetJson(key: string, json: any): boolean {
   if (localStorageAvailable()) {
      window.localStorage.setItem(key, JSON.stringify(json));
      return true;
   } else {
      return false;
   }
}

export function localGetJson(key: string): any | null {
   if (localStorageAvailable()) {
      const json = window.localStorage.getItem(key);
      if (json) {
         return JSON.parse(json);
      } else {
         return null;
      }
   } else {
      return null;
   }
}
